import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

function escapeFilterValue(value) {
  return String(value ?? '')
    .replaceAll('\\', '\\\\')
    .replaceAll('"', '\\"')
    .replaceAll('`', '\\`')
}

export function createTypesenseProvider(rootElement, applicationConfiguration = window.polyestershoppen) {
  const { typesense, config } = applicationConfiguration ?? {}
  const { productListing: listingType } = rootElement.dataset
  const categoryId = Number(rootElement.dataset.categoryId)
  const brand = rootElement.dataset.brand?.trim()
  const indexName = typesense?.collections?.product

  if (!['category', 'brand'].includes(listingType) || !indexName || !typesense.host || !typesense.apiKey || !config?.webshop) {
    throw new Error('Incomplete Typesense product listing configuration.')
  }

  if ((listingType === 'category' && !Number.isInteger(categoryId)) || (listingType === 'brand' && !brand)) {
    throw new Error('A product listing requires its fixed category or brand.')
  }

  const filters = [
    // the category and its subcategories: every product lists the ids from its root category down
    listingType === 'category' ? `category_ids:=${categoryId}` : `brand:=\`${escapeFilterValue(brand)}\``,
    `(is_webshop_restricted:=false || webshops:=\`${escapeFilterValue(config.webshop)}\`)`,
  ]

  // Category listings intentionally include their link products.
  if (listingType === 'brand') {
    filters.unshift('is_link:=false')
  }

  const filterBy = filters.join(' && ')
  const adapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: typesense.apiKey,
      nodes: [{ host: typesense.host, port: typesense.port, protocol: typesense.protocol }],
      numRetries: 8,
      useServerSideSearchCache: true,
    },
    additionalSearchParameters: {
      facet_strategy: 'exhaustive',
      per_page: 20,
      query_by: 'name',
      sort_by: 'sorting_weight:asc',
    },
  })

  return {
    indexName,
    searchClient: adapter.searchClient,
    parameters: { filters: filterBy },
    async getFacetAttributes() {
      const result = await adapter.typesenseClient.collections(indexName).documents().search({
        q: '*',
        facet_by: 'facets.*',
        filter_by: filterBy,
        per_page: 0,
      })
      const attributes = result.facet_counts?.map((facet) => facet.field_name).filter(Boolean) ?? []

      return [...new Set(attributes)].filter((attribute) => listingType !== 'brand' || attribute !== 'facets.brand')
    },
  }
}
